import { render, staticRenderFns } from "./ProductVat.vue?vue&type=template&id=518e2e68&"
import script from "./ProductVat.vue?vue&type=script&lang=ts&"
export * from "./ProductVat.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports